module.exports = __webpack_public_path__ + "static/media/chris.233918b3.jpg";